import * as Types from './types'

const initialState = () => {
  if(localStorage.getItem('jwt-token')) {
    return {
      loggedIn: 1,
      username: localStorage.getItem('username'),
      role: localStorage.getItem('role'),
      invalidateMessage: "",
      loading: false,
      rememberMe: true,
      timeout: localStorage.getItem('timeout')
    }
  }else if(sessionStorage.getItem('jwt-token')) {
    return {
      loggedIn: 1,
      username: sessionStorage.getItem('username'),
      role: sessionStorage.getItem('role'),
      invalidateMessage: "",
      loading: false,
      rememberMe: false,
      timeout: sessionStorage.getItem('timeout')
    }
  }else {
    return {
      loggedIn: 0,
      username: '',
      role: '',
      invalidateMessage: "",
      loading: false,
      rememberMe: false,
      timeout: 0
    }
  }
}

export const authenticationReducer = (state = initialState(), action) => {
  switch(action.type){
    case Types.LOGIN_REQUEST:
      return {
        loggedIn: 0,
        loading: true
      }
    case Types.LOGIN_SUCCESS:
      return {
        loggedIn: 1,
        username: action.username,
        role: action.role,
        rememberMe: action.rememberMe,
        loading: false,
        timeout: action.timeout
      }
    case Types.LOGIN_FAILURE:
      console.log("Login Failure action")
      console.log(action)
      return {
        loggedIn: 0,
        username: '',
        invalidateMessage: action.payload.message,
        loading: false,
        rememberMe: false
      }
    case Types.LOGOUT:
    case Types.LOGOUT_FAILURE:
      return {
        loggedIn: 0,
        username: '',
        invalidateMessage: "",
        loading: false,
        rememberMe: false
      }
    default:
      return state
  }
}